// components/ProtectedRoute.js
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserAuth } from '../context/UserContext';
import { isPrivilegedRole } from '../utils/roles';

export function RestrictedRoute({ children, requiredRole, requirePayment }) {
    const { user } = useUserAuth();
    const location = useLocation();

    // /login-page, not /login: there is no /login route, so this used to fall
    // through to the "*" catch-all and drop signed-out visitors on the homepage
    // instead of the sign-in form. `replace`, so Back from the sign-in page does
    // not bounce straight back into the page that just turned them away.
    if (!user) return <Navigate to="/login-page" replace />;

    // THIS IS FOR TESTING. LETS admins/testers BYPASS ROUTING RESTRICTION
    if (isPrivilegedRole(user.role)) {
        return <Outlet />;
    }

    // requiredRole accepts a single role ("admin") or a list of roles that are
    // all acceptable ([CLIENT_ROLE]). Admins and testers already returned above,
    // so a list never has to spell them out.
    if (requiredRole) {
        const allowed = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
        if (!allowed.includes(user.role)) {
            return <Navigate to="/unauthorized" />;
        }
    }

    if (requirePayment) {
        // Access is granted by EITHER an active/trialing subscription
        // OR a one-time CD Course purchase (courseAccess flag set by the webhook).
        const hasActiveSub =
            user.hasPaid &&
            (user.subscriptionStatus === "trialing" || user.subscriptionStatus === "active");
        const hasCourseAccess = user.courseAccess === true;

        if (!hasActiveSub && !hasCourseAccess) {
            // Remember where the user was headed so checkout can send them back
            // here after payment (see /checkout/success).
            const next = encodeURIComponent(location.pathname + location.search);
            return <Navigate to={`/subscriptions?next=${next}`} replace />;
        }
    }

    return <Outlet />; // ✅ required for nested routes to render
}


// export function RestrictedRouteSiteLock({ children, requiredRole, requirePayment }) {
//     const { user } = useUserAuth();

//     if (!user) return <Navigate to="/login" />;

//     if (requiredRole && user.role !== requiredRole) {
//         return <Navigate to="/unauthorized" />;
//     }

//     if (requirePayment && !user.hasPaid) {
//         // return <Navigate to="/billing" />;
//         return <Navigate to="/subscriptions3" />;
//     }

//     return <Outlet />;
// }